import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";

import CarrierDialogStandardActions from "./CarrierDialogStandardActions";

export default function CarrierStateBondDialogs({ vm }) {
  const {
    handleCloseEditBondDialog,
    handleCloseStateDialog,
    handleCloseBondDialog,
    setUpdatedBondCode,
    openEditBondDialog,
    handleUpdateBond,
    bondsList,
    handleAddBond,
    openStateDialog,
    handleAddState,
    statesList,
    isSubmitting,
    updatedBondCode,
    openBondDialog,
    bondName,
    bondCode,
    setBondCode,
    setBondName,
    stateName,
    setStateName,
  } = vm;

  return (
    <>
      <Dialog open={openStateDialog} onClose={handleCloseStateDialog}>
        <DialogTitle>Add New State</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            select
            margin="dense"
            label="State Name"
            fullWidth
            variant="outlined"
            value={stateName}
            onChange={(e) => setStateName(e.target.value)}
          >
            {statesList.map((option) => (
              <MenuItem key={option.bond_state_id} value={option.bond_state_id}>
                {option.state_name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <CarrierDialogStandardActions
          onCancel={handleCloseStateDialog}
          onSubmit={handleAddState}
          submitting={isSubmitting}
          submitLabel="Add State"
        />
      </Dialog>

      <Dialog open={openBondDialog} onClose={handleCloseBondDialog}>
        <DialogTitle>Add New Bond</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            select
            margin="dense"
            label="Bond Name"
            fullWidth
            variant="outlined"
            value={bondName}
            onChange={(e) => setBondName(e.target.value)}
          >
            {bondsList.map((option) => (
              <MenuItem key={option.bond_type_id} value={option.bond_type_id}>
                {option.type}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            margin="dense"
            label="Bond Code"
            type="text"
            fullWidth
            variant="outlined"
            value={bondCode}
            onChange={(e) => setBondCode(e.target.value)}
          />
        </DialogContent>
        <CarrierDialogStandardActions
          onCancel={handleCloseBondDialog}
          onSubmit={handleAddBond}
          submitting={isSubmitting}
          submitLabel="Add Bond"
        />
      </Dialog>

      <Dialog open={openEditBondDialog} onClose={handleCloseEditBondDialog}>
        <DialogTitle>Edit Bond Code</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Bond Code"
            type="text"
            fullWidth
            variant="outlined"
            value={updatedBondCode}
            onChange={(e) => setUpdatedBondCode(e.target.value)}
          />
        </DialogContent>
        <CarrierDialogStandardActions
          onCancel={handleCloseEditBondDialog}
          onSubmit={handleUpdateBond}
          submitting={isSubmitting}
          submitLabel="Save"
        />
      </Dialog>
    </>
  );
}

CarrierStateBondDialogs.propTypes = {
  vm: PropTypes.object.isRequired,
};
